import { render, staticRenderFns } from "./Lojas.vue?vue&type=template&id=ec0650b4&scoped=true"
import script from "./Lojas.vue?vue&type=script&lang=js"
export * from "./Lojas.vue?vue&type=script&lang=js"
import style0 from "./Lojas.vue?vue&type=style&index=0&id=ec0650b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0650b4",
  null
  
)

export default component.exports